var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"noticeAlerts"},[_c('div',{class:[_vm.type == 'success' ? 'successAlerts' : _vm.type == 'warn' ? 'warnAlerts' : 'errAlerts']},[_vm._v(_vm._s(_vm.title))])])
}
var staticRenderFns = []

export { render, staticRenderFns }